import { marked } from 'marked';
import DOMPurify from 'dompurify';

/**
 * Secure Markdown Utility - Pentest Finding #16 Fix
 * DOMPurify sanitizes HTML: blocks scripts, event handlers, dangerous protocols
 */

// External links: add target="_blank" rel="noopener noreferrer"
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    const href = node.getAttribute('href') || '';
    if (href.startsWith('http')) {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  }
});

/** Parse markdown to sanitized HTML */
export const parseMarkdown = (md: string): string =>
  md ? DOMPurify.sanitize(marked.parse(md) as string) : '';

export { marked };
